// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1LZyn","legacyBtn":"MutateMid_legacyBtn__HeyMs"};